import axios from 'axios';

export default function getStructure() {
  return new Promise((resolve, reject) => axios
    .get('/account/system-admin/api/v1/system-feature-structure')
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message)));
}
